module.exports = __webpack_public_path__ + "img/prop-sunflower-right.83f5cd8d.png";